var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.75,
    height: 27,
    viewBox: "0 0 24.75 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-stats",
    "data-name": "Icon ionic-ios-stats",
    transform: "translate(-5.625 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1973",
    "data-name": "Trac\\xE9 1973",
    d: "M12.938,31.5h3.375a.564.564,0,0,0,.563-.562V5.063a.564.564,0,0,0-.562-.562H12.938a.564.564,0,0,0-.562.563V30.938A.564.564,0,0,0,12.938,31.5Z",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1974",
    "data-name": "Trac\\xE9 1974",
    d: "M6.188,31.5H9.563a.564.564,0,0,0,.563-.562V20.813a.564.564,0,0,0-.562-.562H6.188a.564.564,0,0,0-.562.563V30.938A.564.564,0,0,0,6.188,31.5Z",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1975",
    "data-name": "Trac\\xE9 1975",
    d: "M19.695,31.5h3.361a.567.567,0,0,0,.57-.57V16.32a.567.567,0,0,0-.57-.57H19.695a.567.567,0,0,0-.57.57V30.93A.567.567,0,0,0,19.695,31.5Z",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1976",
    "data-name": "Trac\\xE9 1976",
    d: "M25.875,9.57V30.93a.567.567,0,0,0,.57.57h3.361a.567.567,0,0,0,.57-.57V9.57a.567.567,0,0,0-.57-.57H26.445A.567.567,0,0,0,25.875,9.57Z",
    fill: "#3e3e3e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/Statistics.79f67e2d4ef4a93e8d410ca2eb4cebbd.svg";
export { ForwardRef as ReactComponent };